module.exports = __webpack_public_path__ + "static/media/birb.f39ec99a.jpg";